import { Component, OnInit } from "@angular/core";
import { CommonLoggingProp, LoggingService, RoutingService, SeoService } from "src/app/core";

@Component({
    selector: "app-page-not-found",
    templateUrl: "./page-not-found.component.html",
    styleUrls: ["./page-not-found.component.scss"],
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
  constructor(private _seoService: SeoService, private _loggingService: LoggingService, private _routingService: RoutingService) {}

  ngOnInit() {
    this._seoService.postFixTitle("404 Not Found");

    this._loggingService.logRemoteWarning("Page Not Found Hit", "PageNotFoundComponent.ngOnInit", {
      [CommonLoggingProp.Workflow]: "UserRoute",
      [CommonLoggingProp.WorkflowStep]: "PageNotFound",
      DocReferrer: document.referrer,
      RouteHistory: JSON.stringify(this._routingService.getRouteHistory()),
    });
  }
}
